/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum CustomerPaymentSystemTypeApiModel {
  Ipay = 'ipay',

  Stripe = 'stripe',

  Amp = 'amp',

  _4bill = '4bill',

  Eway = 'eway',

  Flutterwave = 'flutterwave',

  GlobalPayments = 'global-payments',

  Wave = 'wave',

  Pax = 'pax'
}
